import { Box, Button, Typography } from '@mui/material';

interface Props {
  email: string;
  onBackToLogin: () => void;
}

export const ResetSentMessage = ({ email, onBackToLogin }: Props) => (
  <Box sx={{ textAlign: 'center', py: 2 }}>
    <Typography variant="body1" gutterBottom>
      Password reset email sent to {email}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Please check your email for instructions to reset your password.
    </Typography>
    <Button onClick={onBackToLogin} data-qaid="return-to-login-button">
      Return to Login
    </Button>
  </Box>
);
